<div class="field">
  <label class="label" [for]="name ? name : e2eName" data-e2e="textControl-label">
    {{ name }}
    &nbsp;
    <span *ngIf="optional" class="has-text-grey has-text-weight-normal" i18n>(Optional)</span>
  </label>
  <div class="control">
    <input
      #inputRef
      [formControl]="control"
      [attr.data-e2e]="e2eName"
      [ngClass]="{ 'is-danger': invalid }"
      [attr.name]="name"
      type="text"
      class="input"
      [id]="name ? name : e2eName"
      data-e2e="textControl-input"
      [attr.autocomplete]="autocomplete"
      (blur)="onBlur($event)"
    />
    <portal-form-error [formInput]="control" [errorId]="name"></portal-form-error>
  </div>
</div>
